export { default as ExpertInfoMini } from './ExpertInfoMini';
